import API from '../..';
const ENTITY = 'preview';

export const getProposalPreview = (proposalId) =>
    API.get(`/api/v1/${ENTITY}/${proposalId}/`);
